import { SYSTEM_USER_ROLES } from '../../shared/constants/user-roles';

export interface ISsdServiceOrderAccess {
  canEdit: boolean;
  canDispatch: boolean;
  /** When false, Add Claim is blocked regardless of Security admin permissions. */
  canCreateClaim?: boolean;
}

function normalizeRole(roleName?: string): string {
  return String(roleName ?? '')
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, '');
}

/**
 * Service order edit and dispatch limits for the SSD roles:
 *  - SSD - Lite: edit existing claims (status, expenses, accept, etc.), no dispatch, no Add Claim
 *  - SSD-Med:    edit allowed, no dispatch
 *  - SSD-Plus:   edit and dispatch allowed
 * Import access and other actions remain controlled by role permissions in Security admin.
 * Any other role (or a role name that is not loaded yet) returns null so existing behavior is unchanged.
 */
export function getSsdServiceOrderAccess(roleName?: string): ISsdServiceOrderAccess | null {
  switch (normalizeRole(roleName)) {
    case normalizeRole(SYSTEM_USER_ROLES.SSD_LITE):
      return { canEdit: true, canDispatch: false, canCreateClaim: false };
    case normalizeRole(SYSTEM_USER_ROLES.SSD_MED):
      return { canEdit: true, canDispatch: false };
    case normalizeRole(SYSTEM_USER_ROLES.SSD_PLUS):
      return { canEdit: true, canDispatch: true };
    default:
      return null;
  }
}
